import { Breadcrumbs } from '@change/ds-core-ui/next';

import { useLocalBreadcrumbs } from './hooks/useLocalBreadcrumbs';

export const LocalBreadcrumbs: React.FC = () => {
	const {
		data: { items },
	} = useLocalBreadcrumbs();

	return <Breadcrumbs data-qa="breadcrumb-navigation" items={items} maxVisibleTablet={3} />;
};
